/* ShimChingMD — PDP Protocol · reviews (Oct 16).
   Renders the store's real Judge.me reviews for the LED mask on the Protocol pages, in the page's own style.
   Why not the Judge.me widget markup: on this theme Judge.me only hydrates its Shopify app blocks, so the legacy
   <div class="jdgm-widget"> divs render "No reviews" even though the product has 15. The public widget endpoint
   (the same one Judge.me's own widget reads) returns the reviews as JSON, so we read that and render ourselves.
   Nothing is invented: names, dates, ratings and text come straight from Judge.me; bodies are inserted as text. */
(function () {
  'use strict';
  var badge = document.querySelector('[data-rv-badge]');
  var list = document.querySelector('[data-rv-list]');
  if (!badge && !list) return;
  var host = list || badge;
  var productId = host.getAttribute('data-rv-product');
  var shop = host.getAttribute('data-rv-shop');
  if (!productId || !shop) return;
  var S = (function () { try { return JSON.parse(document.querySelector('[data-rv-strings]').textContent); } catch (e) { return {}; } })();
  var t = function (k) { return S[k] != null ? S[k] : k; };
  var url = 'https://judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(shop) + '&shop_domain=' + encodeURIComponent(shop) + '&platform=shopify&per_page=15&product_id=' + encodeURIComponent(productId);

  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function stars(score) {
    var wrap = el('span', 'rv-stars'); wrap.setAttribute('aria-label', score + ' / 5');
    for (var i = 1; i <= 5; i++) { var s = el('span', 'rv-star' + (i <= Math.round(score) ? ' on' : ''), '★'); s.setAttribute('aria-hidden', 'true'); wrap.appendChild(s); }
    return wrap;
  }
  function textOf(html) { var d = document.createElement('div'); d.innerHTML = html || ''; return (d.textContent || '').replace(/\s+/g, ' ').trim(); }
  function fmtDate(iso) { try { return new Date(iso).toLocaleDateString('en-US', { month: 'short', year: 'numeric' }); } catch (e) { return ''; } }

  fetch(url, { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (data) {
    var n = parseInt(data.number_of_reviews, 10) || 0;
    var avg = parseFloat(data.average_rating) || 0;
    var all = (data.reviews || []).filter(function (r) { return r && r.rating; });
    var exAttr = host.getAttribute('data-rv-exclude') || '';
    var words = exAttr.split(',').map(function (w) { return w.trim().toLowerCase(); }).filter(Boolean);
    var reviews = words.length ? all.filter(function (r) {
      var txt = (textOf(r.title) + ' ' + textOf(r.body_html || r.body)).toLowerCase();
      return !words.some(function (w) { return txt.indexOf(w) !== -1; });
    }) : all;
    var filtered = reviews.length !== all.length;
    if (!n || !reviews.length) return; // leave the badge hidden and the section collapsed: never show an empty state


    if (badge) {
      badge.innerHTML = '';
      var a = el('a', 'rv-badge'); a.href = '#reviews';
      a.appendChild(stars(avg));
      a.appendChild(el('span', 'rv-badge-txt', filtered ? t('rv_product') : avg.toFixed(1) + ' · ' + n + ' ' + t(n === 1 ? 'rv_one' : 'rv_many')));      var note = badge.getAttribute('data-rv-note'); if (note) a.appendChild(el('span', 'rv-badge-note', note));
      badge.appendChild(a); badge.hidden = false;
      a.addEventListener('click', function (ev) { var sec = document.getElementById('reviews'); if (sec) { ev.preventDefault(); sec.scrollIntoView({ behavior: 'smooth', block: 'start' }); } });
    }

    if (list) {
      list.innerHTML = '';
      var sum = el('div', 'rv-sum');
      sum.appendChild(el('b', 'rv-sum-num tnum', avg.toFixed(1)));
      var sumR = el('div', 'rv-sum-r'); sumR.appendChild(stars(avg)); sumR.appendChild(el('span', 'rv-sum-n', n + ' ' + t(n === 1 ? 'rv_one' : 'rv_many') + ' · ' + t('rv_product'))); sum.appendChild(sumR);
      if (!filtered) list.appendChild(sum);
      var grid = el('div', 'rv-grid rvs');
      var INITIAL = 6;
      reviews.forEach(function (r, i) {
        var c = el('article', 'rv-card'); c.style.setProperty('--i', i % INITIAL); if (i >= INITIAL) c.hidden = true;
        var head = el('div', 'rv-head'); head.appendChild(stars(r.rating)); head.appendChild(el('span', 'rv-date', fmtDate(r.created_at))); c.appendChild(head);
        if (r.title) c.appendChild(el('h3', 'rv-title', textOf(r.title)));
        var body = textOf(r.body_html || r.body); if (body) c.appendChild(el('p', 'rv-body', body));
        var who = el('div', 'rv-who'); who.appendChild(el('b', null, r.reviewer_name || t('rv_anon')));
        if (r.verified_buyer) who.appendChild(el('span', 'rv-tag', t('rv_verified')));
        c.appendChild(who);
        grid.appendChild(c);
      });
      list.appendChild(grid);
      if (reviews.length > INITIAL) {
        var more = el('button', 'rv-more', t('rv_more').replace('{n}', reviews.length - INITIAL)); more.type = 'button';
        more.addEventListener('click', function () { grid.querySelectorAll('.rv-card[hidden]').forEach(function (x) { x.hidden = false; }); more.remove(); });
        list.appendChild(more);
      }
      list.appendChild(el('p', 'rv-foot', t('rv_foot')));
      var sec = list.closest('[data-rv-section]'); if (sec) sec.hidden = false;
      if (window.__scmdReveal) { try { window.__scmdReveal(grid); } catch (e) {} }
      grid.classList.add('in');
    }
  }).catch(function () { /* stay hidden */ });
})();
